import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo-sheetlabels.svg'


const _hoisted_1 = { id: "nav-bar-component" }
const _hoisted_2 = { id: "nav-bar-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  id: "sli-logo",
  src: _imports_0,
  alt: "Sheetlabels.com logo"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "nav-btns"
}
const _hoisted_5 = {
  key: 1,
  class: "nav-btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrintButton = _resolveComponent("PrintButton")!
  const _component_SaveButton = _resolveComponent("SaveButton")!
  const _component_SaveAndContinue = _resolveComponent("SaveAndContinue")!
  const _component_SaveTemplate = _resolveComponent("SaveTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_ctx.urlProperties.isCreatingTemplate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_PrintButton),
            _createVNode(_component_SaveButton),
            _createVNode(_component_SaveAndContinue)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_SaveTemplate)
          ]))
    ])
  ]))
}